import React from "react";
import { Card, Row, Col, Typography, Button, Space, Tag } from "antd";
import { AppleFilled, AndroidFilled, MobileOutlined } from "@ant-design/icons";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";

// Store links (single source of truth — the QR code is generated from these).
const IOS_URL = "https://apps.apple.com/de/app/medistime/id6778660614";
const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=de.optivasoft.meditimex_mobile";

const { Title, Text, Paragraph } = Typography;

const StoreCard = ({ url, icon, platform, cta, badge, note }) => (
  <Col xs={24} sm={12}>
    <Card style={{ height: "100%", textAlign: "center" }}>
      <Space direction="vertical" size="middle" align="center" style={{ width: "100%" }}>
        <Space align="center" size="small">
          {icon}
          <Text strong style={{ fontSize: 18 }}>
            {platform}
          </Text>
          {badge}
        </Space>

        <a href={url} target="_blank" rel="noopener noreferrer" aria-label={cta}>
          <div
            style={{
              background: "#ffffff",
              padding: 12,
              borderRadius: 8,
              border: "1px solid #f0f0f0",
              display: "inline-block",
              lineHeight: 0,
            }}
          >
            <QRCodeSVG value={url} size={160} level="M" />
          </div>
        </a>

        <Button type="primary" icon={icon} href={url} target="_blank" rel="noopener noreferrer">
          {cta}
        </Button>

        {note && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {note}
          </Text>
        )}
      </Space>
    </Card>
  </Col>
);

// Advertises the iOS + Android mobile apps on the landing page, each with a QR
// code that opens the relevant store. Android is in closed testing, so it's
// clearly labelled as Beta.
const MobileAppPromo = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: "48px 24px" }}>
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <Title level={2}>
          <MobileOutlined style={{ marginRight: 8 }} />
          {t("appPromo.title")}
        </Title>
        <Paragraph type="secondary">{t("appPromo.subtitle")}</Paragraph>
      </div>

      <Row gutter={[24, 24]} justify="center" style={{ maxWidth: 720, margin: "0 auto" }}>
        <StoreCard
          url={IOS_URL}
          icon={<AppleFilled />}
          platform="iOS"
          cta={t("appPromo.appStore")}
        />
        <StoreCard
          url={ANDROID_URL}
          icon={<AndroidFilled />}
          platform="Android"
          cta={t("appPromo.googlePlay")}
          badge={<Tag color="orange">{t("appPromo.beta")}</Tag>}
          note={t("appPromo.androidNote")}
        />
      </Row>

      <Paragraph
        type="secondary"
        style={{ textAlign: "center", marginTop: 16, fontSize: 12 }}
      >
        {t("appPromo.scanHint")}
      </Paragraph>
    </div>
  );
};

export default MobileAppPromo;
